import React, { Component } from 'react';
import { request } from 'http';


const Data = [
	{
		icon:require('./img/gmailIcon.png'),
		b:"Gmail",
		items: [
			{
				icon: require('./img/OutlookIcon.png'),
				b: "Microsoft Outlook",
				k: "noGmail0_outlook",
				t: "Meet Outlook for Android, the app that helps millions of users connect all their email accounts, calendars and files in one convenient spot. Newly redesigned, Outlook for Android lets you do more from one powerful inbox."
			},
			{
				icon: require('./img/YahooIcon.png'),
				b: "Yahoo Mail – Stay Organized",
				k: "noGmail1_yahooMail",
				t: "The best email app to easily organize your Gmail, Outlook (Hotmail), AOL and Yahoo accounts. Regardless of your email address, you can experience the Yahoo Mail app's beautiful design, easy-to-use interface and lightning fast speed. Plus, Yahoo Mail offers 1000 GB of free secure cloud storage, so you never have to worry about space again."
			},
			{
				icon: require('./img/myMailIcon.png'),
				k: "noGmail2_myMail",
				b: "myMail – Email for Hotmail, Gmail and Outlook Mail",
				t: "myMail – Manage all your email accounts at once! Whether it’s Hotmail, Gmail, Yahoo, Outlook, AOL, iCloud, Live, Exchange or GMX, myMail email client supports all major mail providers and any other IMAP or POP3-enabled mailbox."
			},
		]		
	}, 
	{
		icon:require('./img/chromeIcon.png'),
		b:"Chrome",
		t:"Google Chrome is a fast, easy to use, and secure web browser. Designed for Android, Chrome brings you personalized news articles, quick links to your favorite sites, downloads, and Google Search and Google Translate built-in. Download now to enjoy the same Chrome web browser experience you love across all your devices.",
		items: [
			{
				icon: require('./img/fireFox.png'),
				k: "noChrome0_firefox",
				b: "Firefox Browser fast & private",
				t: "Experience a fast, smart and personal Web. Firefox is the independent, people-first browser made by Mozilla, voted the Most Trusted Internet Company for Privacy. Upgrade today and join hundreds of millions who depend on Firefox for a more personal browsing experience."
			},
			{
				icon: require('./img/opera.png'),
				k: "noChrome1_opera",
				b: "Opera browser - news & search",
				t: "Your Android browser should do more than just display web pages. Opera for Android now has a built-in news feed that helps you find more content you’ll love - it also saves data by blocking ads and compressing images."
			},
		]	
	}, 
	{
		icon:require('./img/gMapsIcon.png'),
		b:"Maps - Navigation & Transit",
		t:"Going somewhere? Go with Maps, the official app you can rely on for real-time GPS navigation, traffic, transit, and details about millions of places, such as reviews and popular times.",
		items: [
			{
				icon: require('./img/streetMaps.png'),
				b: "Street Maps",
				k: "noGMaps0_streerMaps",
				t: "Taxi drivers, couriers, transport companies, travel agents, drivers, pedestrians, tourists, thieves, policemen, people on the move; this application must be in your pocket."
			},
			{
				icon: require('./img/offlinemapIcon.png'),
				b: "Offline Maps & Navigation",
				k: "noGMaps1_offlineMaps",
				t: "Free navigation app that combines the best of offline and online features to create the ultimate navigation experience. Compact maps of over 200 countries were specially optimized to take up less space on your phone. Follow accurate voice directions, avoid traffic jams and get speed limit & speed camera alerts. Regular map updates, no hidden costs."
			},
		]
	}, 
	{
		icon:require('./img/gClndIcon.png'),
		b:"Google Calendar",
		t:"Get the official Google Calendar app for your Android phone and tablet to save time and make the most of every day.",
		items: [
			{
				icon: require('./img/busnisCalnd.png'),
				b: "Business Calendar 2",
				k: "noGCalendar0_businessCalendar",
				t: "Business Calendar 2 is the successor of our award-winning calendar app."
			},
			{
				icon: require('./img/digiCal.png'),
				b: "DigiCal Calendar Agenda",
				k: "noGCalendar1_digiCal",
				t: "Our daily planner has a clean design and multiple agenda views to make scheduling quick and easy."
			},
			{
				icon: require('./img/simpleCln.png'),
				b: "Simple Calendar",
				k: "noGCalendar2_simpleCalendar",
				t: "A simple calendar with optional CalDAV synchronization. You can easily create recurring events and setup reminders, it can also display week numbers."
			},
		]
	},
	{
		icon:require('./img/youtubeIcon.png'),
		b:"YouTube",
		t:"Get the official YouTube app for Android phones and tablets. See what the world is watching -- from the hottest music videos to what’s trending in gaming, entertainment, news, and more. Subscribe to channels you love, share with friends, and watch on any device.",
		items: [
			{
				icon: require('./img/vSearchYoutube.png'),
				b: "Video Search for YouTube",
				k: "noYouTube0_VideoSearch",
				t: "Search videos in YouTube by video title with Video Search for YouTube and save your time and traffic."
			},
			{
				icon: require('./img/minYoutube.png'),
				b: "Minimizer for YouTube",
				k: "noYouTube1_MinimizerForYouTube",
				t: 'Introducing "Ghost Mode"! You can now touch things behind the window, like YouTube is completely minimized!'
			},
		]
	},
	{
		icon:require('./img/googleSearchIcon.png'),
		b:"Google Search",
		t:"The Google app keeps you in the know about the things you care about. Find quick answers, explore your interests, and get personalized updates in your Google feed. The more you use the Google app, the better it gets.",
		items: [
			{
				icon: require('./img/SmartSearchIcon.png'),
				b: "Smart Search & Web Browser",
				k: "noGSearch0_smartSearch",
				t: "Super fast Web browser for Android will help you to get search results from various search engines like Google, Bing and other popular Internet Web services like YouTube, Amazon, eBay and Wikipedia."
			},
			{
				icon: require('./img/searchEverythingIcon.png'),
				b: "Search Everything",
				k: "noGSearch1_searchEverything",
				t: 'Search Everything - The fastest possible way to access your files. Gives you instant file search results!'
			},
			{
				icon: require('./img/bingSerachIcon.png'),
				b: "Microsoft Bing Search",
				k: "noGSearch2_bing",
				t: "Bing is more than simple search. Get answers to your questions faster and easier. Find what you love, from live sport updates, trending music, and recipes, to nearby deals, movie times, and gas prices. Explore your world with 360 search powered by augmented reality in the Near Me–Camera Search tab."
			},
		]
	}, 
	{
		icon:require('./img/gDocsIcon.png'),
		b:"Google Docs",
		t:"Create, edit and collaborate with others on documents from your Android phone or tablet with the Google Docs app.",
		items: [
			{
				icon: require('./img/wordIcon.png'),
				b: "Microsoft Word",
				k: "noGDocs0_word",
				t: "The familiar Word app lets you create, edit, view and share your files with others quickly and easily. It also lets you view and edit Office doc attached to email messages."
			},
			{
				icon: require('./img/WPF_icon.png'),
				b: "WPS Office - Word, Docs, PDF, Note, Slide & Sheet",
				k: "noGDocs1_WPS",
				t: 'WPS Office is the smallest size (less than 35MB) and all-in-one complete free office suite on Android mobile and tablets, integrates all office word processor functions: Word, PDF, Presentation, Spreadsheet.'
			},
			{
				icon: require('./img/polarIcon.png'),
				b: "Polaris Office - Word, Docs, Sheets, Slide, PDF",
				k: "noGDocs2_polaris",
				t: `Already 70 Million Users Across The World, Get the Latest Android Office App For Free.
				Experience New All-in-One Complete Office Suite compatible with MS Word, Excel, PowerPoint and Adobe PDF. "Editors' Choice", "2015 Best App", and "Top Developer"awarded by Google Play.`
			},
		]
	}, 
]
class Row extends Component {
	state = {on: false}
	componentDidMount() {
		this.updateValue()
		this.updateValue = this.updateValue.bind(this)
	}
	updateValue() {
		const {k} = this.props.data
		k && global.setAnswer(k, this.state.on)
	}
	render() {
		const {data} = this.props
		return <div>
			<div style={{
				marginTop: 15,
				display:"flex",
			}}>
				<img src={data.icon} style={{
					width:20,
					height:20,
					marginLeft:20,
					marginTop:5,
					// opacity:0.7
				}} />
				<div style={{
					width: data.noBtn ? 276	: 236,
					marginLeft:20,
					
				}}>
					<span style={{
						fontWeight:"bold",
						fontSize: 13,
					}}>{data.b}</span>
					<span style={{
						fontSize:13,				
						
					}}> {data.t}</span>
				</div>
				{!data.noBtn && <img src={this.state.on ? require('./img/rOn.png'): require('./img/rOff.png')} 
					onClick={() => this.setState({on:!this.state.on}, this.updateValue)}
					style={{
						cursor:"pointer",
						width:45,
						height:45,
						alignSelf:"center"	

					}}
				/>}
			</div>
			<div style={{
				marginLeft: 60,
				width:276,
				height:1,
				backgroundColor:"black",
				opacity:0.2,
				marginTop:15
			}} />
		</div>
	}
}
	

export default class NotGoogleApps extends Component {
	render() {
		const {t,l} = this.props
		return <div style={{
			position:"absolute",
			left: 0,
			top: 0,
			width:360,
			height: global.isMobile ? (3082 + 500) : (2974 + 500),
			fontSize:16,
		}}>
			<img src={require('./img/logo.jpg')} style={{
				position:"absolute",
				left: 24,
				top: 32,
				width:32,
				height:32
			}} />
			<div style={{
				position:"absolute",
				left: 24,
				top: 96,
				width:360 - 48,
				height:100,
			}}>
				<span style={{
					
					fontWeight:"bold"	
				}}>Alternative Applications</span>
				<br/>
				<br/>
				<span>
					There are other apps in the Play store that 
					can be used to fulfill the same function 
					as some of the 
					Google applications. For example there 
					are other browsers, other calendars, 
					other email readers etc.
				</span>
				<br/>
				<br/>
				<span>
					 If you want to install other applications 
					 tell us which other applications 
					 you wish to install. 
					 Note that you can use this apps instead or 
					 along side the google apps.
				</span>
			</div>
			<div style={{
				position:"absolute",
				top:320,
			}}>
				{Data.map((_,i) => <div style={{
					marginTop:20	
				}}>
					<span style={{
						marginLeft:20,
						fontWeight:"bold",
						fontSize: 14,
					}}>Alternative for {_.b}</span>
					{_.items.map((_2, j) => <Row data={_2} key={j}/>)}
				</div>)}
			</div>
			
		</div>
	}

}



// WEBPACK FOOTER //
// ./src/Comp/NotGoogleApps.js